import * as React from "react";
import { APIConfig, linkAuthGetData } from "../API";
import { Loading, isLoading, loading } from "../Loading";
import { Redirect } from "react-router";
import { LoginState } from "..";
import { AgencyMemberAuthInfo } from "../messages/Auth";

export interface ShortCodeProps {
    apiConfig: APIConfig;
    // I know this is not the best solution but currently the state is what decides what is rendered
    // in the parent component...
    // this makes it so we can change the rendered routes...
    updateUpperState: (loginState: LoginState) => void;
    path: string;
}

export interface ShortCodeState {
    returnState: Loading | boolean;
    authData: null | AgencyMemberAuthInfo;
}

export class ShortCodeAuth extends React.Component<ShortCodeProps, ShortCodeState> {
    constructor(props: ShortCodeProps) {
        super(props);
        this.state = {
            returnState: loading(),
            authData: null
        };
    }

    componentWillMount() {
        this.getAuth();
        this.props.updateUpperState({
            type: "EmptyState"
        });
    }

    async getAuth() {
        const defraggedPath = this.props.path.split("/");
        const shortCode = defraggedPath[defraggedPath.length - 1];
        try {
            if (shortCode === "" || shortCode === "code") {
                throw new Error("No Code Provided");
            }
            const authData = await linkAuthGetData(this.props.apiConfig, shortCode);
            this.setState({
                authData: authData,
                returnState: true
            });
        } catch {
            this.setState({
                authData: null,
                returnState: false
            });
        }
    }

    saveToLocalStorageAndRedirect() {
        const authData = this.state.authData as AgencyMemberAuthInfo;
        localStorage.setItem("agencyMemberAuthInfo", JSON.stringify(authData));
        localStorage.setItem("fromCode", JSON.stringify(true));
        this.props.updateUpperState({
            type: "WithAgencyMemberAuthInfo",
            agencyMemberAuthInfo: authData
        });
        return <Redirect to="/" />;
    }

    noAuthState() {
        localStorage.removeItem("agencyMemberAuthInfo");
        localStorage.removeItem("fromCode");
        // I know this is not the best solution but currently the state is what decides what is rendered
        // in the parent component...
        // this resets the info to the
        this.props.updateUpperState({
            type: "NoAuth"
        });
        return <Redirect to="/" />;
    }

    render() {
        return (
            <div>
                {isLoading(this.state.returnState) ? `Loading....` : this.state.returnState ? this.saveToLocalStorageAndRedirect() : this.noAuthState()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/activities/ShortCodeAuth.tsx